import { avatarColors, deterministicColor } from "../../lib/deterministicColor.js";
import "./ProfileIdentity.css";

function ProfileAvatar({ name }) {
  const normalizedName = name.trim();
  const initial = Array.from(normalizedName)[0]?.toLocaleUpperCase() ?? "?";
  return <span className="profile-avatar" style={{ "--profile-color": deterministicColor(normalizedName, avatarColors) }} aria-hidden="true">{initial}</span>;
}

export function ProfileIdentity({ profile }) {
  return <span className="profile-identity"><ProfileAvatar name={profile.name} /><strong>{profile.name}</strong></span>;
}
